import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/opt/build/repo/src/components/default-layout-narrow.js";
import { Anchor, Text, Box } from "grommet";
import { PlainLink } from "../../components/atomic/TattleLinks";
import { LatestProductBlogsUpdates } from "../../components/LatestProductBlogsUpdates";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1>{`Deepfakes Analysis Unit`}</h1>
    <div style={{
      "textAlign": "center"
    }}>
    <img src="/products/dau-illustration.jpg" alt="Example Image" width="750" height="450"></img>
    </div>
    <p>{`Tattle is developing the collaboration `}<a parentName="p" {...{
        "href": "https://github.com/tattle-made/dau"
      }}>{`platform`}</a>{` powering the DAU WhatsApp tipline. The platform facilitates the triaging, prioritization, and authentication of manipulated media content for escalation to fact-checkers and forensics experts. Users not only have the ability to submit queries but also receive an `}<a parentName="p" {...{
        "href": "https://dau.mcaindia.in/all-reports"
      }}>{`assessment report`}</a>{` detailing the extent of manipulation for each media item queried.`}</p>
    <p>{`You can view more information about the project `}<a parentName="p" {...{
        "href": "https://github.com/tattle-made/DAU"
      }}>{`here`}</a>{`, check out the open issues `}<a parentName="p" {...{
        "href": "https://github.com/tattle-made/DAU/issues"
      }}>{`here`}</a>{`, and learn how to contribute `}<a parentName="p" {...{
        "href": "https://github.com/tattle-made/DAU/blob/main/CONTRIBUTING.md"
      }}>{`here`}</a>{`.`}</p>
    <h2>{`About the DAU`}</h2>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://dau.mcaindia.in/"
      }}>{`DAU's`}</a>{` (Deepfakes Analysis Unit) mission is to generate awareness on algorithm-based manipulation of media content. Through its tipline and partnerships, it aims to enable users to combat generative AI-based fabrication. This endeavor is a collaborative venture involving journalists, academics, and companies, pooling efforts to confront the escalating threat of deepfakes.`}</p>
    <h2>{`Relevant writings`}</h2>
    <Box margin={{
      top: "small",
      bottom: "small"
    }} mdxType="Box">
      <Anchor href="https://tattle.co.in/blog/2024-04-03-securing-feluda-pt1" mdxType="Anchor">Securing your Codebase</Anchor>
    </Box>
    <h2>{`Organisations involved`}</h2>
    <a href="https://mcaindia.in/"><Text size={"small"} mdxType="Text">Misinformation Combat Alliance</Text></a>
    <Text size={"small"} mdxType="Text">Tattle</Text>
    <Text size={"small"} mdxType="Text">Meta (Funding Partner)</Text>
    <LatestProductBlogsUpdates projects={["dau"]} mdxType="LatestProductBlogsUpdates" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      